var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col justify-center items-center h-screen text-primary pb-20",
    },
    [
      _vm._m(0),
      _c(
        "RouterLink",
        {
          staticClass: "hover:text-primary-600 hover:underline text-lg",
          attrs: { to: "/" },
        },
        [_vm._v(" Go to home page ")]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "flex flex-col justify-center items-center border-4 border-primary rounded-full w-60 h-60 mb-4",
      },
      [
        _c("p", { staticClass: "font-bold text-6xl" }, [_vm._v("404")]),
        _c("h2", { staticClass: "text-2xl pb-4" }, [_vm._v("Page not found")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }